import React from 'react';
import PropTypes from 'prop-types';

export default class SelectWrapper extends React.Component {

  render() {
    const options = this.props.options;
    const valueIndex = options
      .filter((option) => option)
      .findIndex((option) => option.value === this.props.value);
    const id = this.props.name || this.props.id || `select-${Math.random().toString().replace(/\./, '')}`;
    return (
      <div className="input-wrapper input-wrapper-select">
        <select
          name={this.props.name || id}
          id={this.props.id || id}
          value={valueIndex}
          onChange={(event) => this.props.onChange((options[+event.target.value] || {}).value, options[+event.target.value], event.target.value)}
        >
          {
            this.props.placeholder ? (
              <option disabled value={-1}>{this.props.placeholder}</option>
            ) : null
          }
          {
            this.props.options.map((option, index) => (
              <option value={index} key={index}>{option.label}</option>
            ))
          }
        </select>
        <label htmlFor={id}><i className="fa fa-caret-down" /></label>
      </div>
    );
  }

}

SelectWrapper.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.any.isRequired,
      disabled: PropTypes.any
    })
  ).isRequired,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  id: PropTypes.string
};




// WEBPACK FOOTER //
// ./src/components/select.js